import { useForm } from "react-hook-form";
import { useState, useEffect, useContext } from "react";
import { LOGIN } from "../../utils/mutations";
import { useMutation } from "@apollo/client";
import { AuthContext } from "../../context/Auth";
import toast from "react-hot-toast";

export default function LoginForm() {
  const { login } = useContext(AuthContext);
  const [loader, setLoader] = useState(false);

  const notifyError = () =>
    toast.error("Please check your account credentials!");

  const { register, handleSubmit } = useForm();

  const [doLogin, { loading, error }] = useMutation(LOGIN, {
    update(_, { data: { login: userData } }) {
      login(userData);
    },
  });

  const onSubmit = (data) => {
    const { email, password } = data.login;
    doLogin({
      variables: {
        email: email.toLowerCase(),
        password,
      },
    });
  };

  useEffect(() => {
    if (loading) setLoader(true);
  }, [loading]);

  useEffect(() => {
    if (error) {
      setLoader(false);
      notifyError();
    }
  }, [error]);

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-2">
      <div>
        <label className="label">
          <span className="label-text font-semibold">Email address</span>
        </label>
        <input
          type="email"
          placeholder="john.doe@email.com"
          className="input input-bordered w-full"
          {...register("login.email")}
          required
        />
      </div>
      <div>
        <label className="label">
          <span className="label-text font-semibold">Password</span>
        </label>
        <input
          type="password"
          placeholder="********"
          className="input input-bordered w-full"
          {...register("login.password")}
          required
        />
      </div>
      <div className="pt-4">
        <button
          type="submit"
          className={
            loader ? "btn btn-accent w-full loading" : "btn btn-accent w-full"
          }
        >
          Login
        </button>
      </div>
    </form>
  );
}
